module.exports = __webpack_public_path__ + "static/media/nightguard.1d617ca2.jpg";